/* ========================================================================
   Pre-Order Multi-Step Flow — Vanilla JS
   Namespace: pof (pre-order flow)
   ======================================================================== */
(function () {
  'use strict';

  document.querySelectorAll('[data-pof-section]').forEach(initSection);

  function initSection(root) {
    if (root.dataset.pofInit === '1') return;
    root.dataset.pofInit = '1';

    var configEl = root.querySelector('[data-pof-config]');
    if (!configEl) return;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    /* ---- state ---- */
    var state = {
      step: 1,
      maxStepReached: 1,
      brandIdx: -1,
      file: null,
      addrIdx: 0,
      shippingAddrIdx: 0,
      shippingSameAsBilling: true,
      billingAddressSource: 'existing',   // existing | new
      shippingAddressSource: 'same_as_billing', // existing | new | same_as_billing
      submitting: false
    };

    /* ---- DOM refs ---- */
    var stepperItems   = root.querySelectorAll('[data-pof-stepper]');
    var panels         = root.querySelectorAll('[data-pof-panel]');
    var brandCards      = root.querySelectorAll('[data-pof-brand]');
    var conditionsWrap  = root.querySelector('[data-pof-conditions]');
    var condBrand       = root.querySelector('[data-pof-cond-brand]');
    var condMoq         = root.querySelector('[data-pof-cond-moq]');
    var condDelivery    = root.querySelector('[data-pof-cond-delivery]');
    var condMinVal      = root.querySelector('[data-pof-cond-minval]');
    var condPayment     = root.querySelector('[data-pof-cond-payment]');
    var dlBrandNames    = root.querySelectorAll('[data-pof-dl-brand]');
    var dlLink          = root.querySelector('[data-pof-dl-link]');
    var dlLinkText      = root.querySelector('[data-pof-dl-text]');
    var dropzone        = root.querySelector('[data-pof-dropzone]');
    var fileInput       = root.querySelector('[data-pof-file-input]');
    var filePreview     = root.querySelector('[data-pof-file-preview]');
    var fileNameEl      = root.querySelector('[data-pof-file-name]');
    var fileStatusEl    = root.querySelector('[data-pof-file-status]');
    var addrSelect      = root.querySelector('[data-pof-addr-select]'); // billing select (kept for backwards compatibility)
    var shippingSelect  = root.querySelector('[data-pof-shipping-select]');
    var shipSameCb      = root.querySelector('[data-pof-ship-same]');
    var shippingWrap    = root.querySelector('[data-pof-shipping-wrap]');
    var billingNewWrap  = root.querySelector('[data-pof-billing-new]');
    var shippingNewWrap = root.querySelector('[data-pof-shipping-new]');
    var billingAddBtn   = root.querySelector('[data-pof-billing-add]');
    var shippingAddBtn  = root.querySelector('[data-pof-shipping-add]');
    var billingCancel   = root.querySelector('[data-pof-billing-cancel]');
    var shippingCancel  = root.querySelector('[data-pof-shipping-cancel]');
    var billingCloseBtn = root.querySelector('[data-pof-billing-close]');
    var shippingCloseBtn = root.querySelector('[data-pof-shipping-close]');
    var billingSaveBtn  = root.querySelector('[data-pof-billing-save]');
    var shippingSaveBtn = root.querySelector('[data-pof-shipping-save]');

    var billingNew = {
      company:  root.querySelector('[data-pof-billing-company]'),
      first:    root.querySelector('[data-pof-billing-first]'),
      last:     root.querySelector('[data-pof-billing-last]'),
      address1: root.querySelector('[data-pof-billing-address1]'),
      address2: root.querySelector('[data-pof-billing-address2]'),
      zip:      root.querySelector('[data-pof-billing-zip]'),
      city:     root.querySelector('[data-pof-billing-city]'),
      country:  root.querySelector('[data-pof-billing-country]'),
      phone:    root.querySelector('[data-pof-billing-phone]')
    };
    var shippingNew = {
      company:  root.querySelector('[data-pof-shipping-company]'),
      first:    root.querySelector('[data-pof-shipping-first]'),
      last:     root.querySelector('[data-pof-shipping-last]'),
      address1: root.querySelector('[data-pof-shipping-address1]'),
      address2: root.querySelector('[data-pof-shipping-address2]'),
      zip:      root.querySelector('[data-pof-shipping-zip]'),
      city:     root.querySelector('[data-pof-shipping-city]'),
      country:  root.querySelector('[data-pof-shipping-country]'),
      phone:    root.querySelector('[data-pof-shipping-phone]')
    };
    var vatInput        = root.querySelector('[data-pof-vat]');
    var submitBtn       = root.querySelector('[data-pof-submit]');
    var errorEls        = root.querySelectorAll('[data-pof-error]');
    var nextBtns        = root.querySelectorAll('[data-pof-next]');
    var backBtns        = root.querySelectorAll('[data-pof-back]');

    /* ---- helpers ---- */
    function formatBytes(b) {
      if (!b) return '0 B';
      var u = ['B', 'KB', 'MB', 'GB'], s = b, i = 0;
      while (s >= 1024 && i < u.length - 1) { s /= 1024; i++; }
      return s.toFixed(i === 0 ? 0 : 1) + ' ' + u[i];
    }

    function showError(stepNum, msg) {
      errorEls.forEach(function (el) {
        if (el.closest('[data-pof-panel]').getAttribute('data-pof-panel') === String(stepNum)) {
          el.textContent = msg;
          el.hidden = false;
        }
      });
    }
    function clearErrors() {
      errorEls.forEach(function (el) { el.hidden = true; el.textContent = ''; });
    }

    /* ---- stepper ---- */
    function updateStepper() {
      stepperItems.forEach(function (el) {
        var n = parseInt(el.getAttribute('data-pof-stepper'), 10);
        el.classList.toggle('is-active', n === state.step);
        el.classList.toggle('is-completed', n < state.step);
      });
    }

    /* ---- stepper: click to go back ---- */
    stepperItems.forEach(function (el) {
      // Make non-interactive nodes keyboard accessible
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');

      function jumpBack() {
        var n = parseInt(el.getAttribute('data-pof-stepper'), 10);
        if (!n || isNaN(n)) return;
        // Allow jumping to already reached steps only (back or forward within progress)
        if (typeof state.step !== 'number') return;
        var maxReached = (typeof state.maxStepReached === 'number' && state.maxStepReached) ? state.maxStepReached : state.step;
        if (n > maxReached) return;
        if (n === state.step) return;
        goTo(n);
      }

      el.addEventListener('click', function (e) {
        e.preventDefault();
        jumpBack();
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          jumpBack();
        }
      });
    });

    var ANIM_OUT = 280;
    var ANIM_IN  = 400;
    var transitioning = false;

    function getPanel(step) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-pof-panel') === String(step)) return panels[i];
      }
      return null;
    }

    function smoothScrollTo(el) {
      var y = el.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    function stripAnimClasses(el) {
      el.classList.remove('is-entering-right', 'is-entering-left', 'is-exiting-right', 'is-exiting-left');
    }

    function goTo(newStep) {
      if (transitioning) return;
      clearErrors();

      var oldStep = state.step;
      var forward = (typeof newStep === 'string') || newStep > oldStep;
      var oldPanel = getPanel(oldStep);
      var newPanel = getPanel(newStep);

      if (!newPanel) return;
      if (oldPanel === newPanel) {
        state.step = newStep;
        updateStepper();
        return;
      }

      transitioning = true;
      state.step = newStep;
      updateStepper();

      if (oldPanel) {
        stripAnimClasses(oldPanel);
        oldPanel.classList.add(forward ? 'is-exiting-left' : 'is-exiting-right');
      }

      setTimeout(function () {
        if (oldPanel) {
          stripAnimClasses(oldPanel);
          oldPanel.hidden = true;
        }
        newPanel.hidden = false;
        stripAnimClasses(newPanel);
        newPanel.classList.add(forward ? 'is-entering-right' : 'is-entering-left');
        smoothScrollTo(root);

        setTimeout(function () {
          stripAnimClasses(newPanel);
          transitioning = false;
        }, ANIM_IN);
      }, ANIM_OUT);
    }

    /* ---- Step 1: brand selection ---- */
    function selectBrand(idx) {
      state.brandIdx = idx;
      brandCards.forEach(function (c, i) { c.classList.toggle('is-selected', i === idx); });

      var brand = cfg.brands[idx];
      if (!brand || !conditionsWrap) return;

      if (condBrand)    condBrand.textContent    = brand.name;
      if (condMoq)      condMoq.textContent      = brand.moq;
      if (condDelivery)  condDelivery.textContent  = brand.delivery;
      if (condMinVal)    condMinVal.textContent    = brand.minVal;
      if (condPayment)  condPayment.textContent  = brand.payment;
      conditionsWrap.hidden = false;
    }

    brandCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var idx = parseInt(card.getAttribute('data-pof-brand'), 10);
        if (isNaN(idx) || idx < 0) return;
        selectBrand(idx);
      });
    });

    /* ---- Step 2: download ---- */
    function updateDownloadStep() {
      var brand = cfg.brands[state.brandIdx];
      if (!brand) return;
      dlBrandNames.forEach(function (el) { el.textContent = brand.name; });
      if (dlLinkText) dlLinkText.textContent = 'Download ' + brand.name + ' Order Template (xlsx)';
      if (dlLink) {
        dlLink.href = brand.templateUrl || '#';
        if (!brand.templateUrl) dlLink.removeAttribute('href');
      }
    }

    /* ---- Step 3: file upload ---- */
    function validateFile(f) {
      if (!f) return 'Please select a file.';
      var ext = (f.name || '').split('.').pop().toLowerCase();
      if (ext !== 'xlsx' && ext !== 'xls' && ext !== 'csv') return 'Invalid file type. Please upload .xlsx, .xls, or .csv.';
      if (f.size > 20 * 1024 * 1024) return 'File exceeds 20 MB limit.';
      return null;
    }

    function handleFile(f) {
      clearErrors();
      var err = validateFile(f);
      if (err) { showError(3, err); return; }
      state.file = f;
      if (fileNameEl)   fileNameEl.textContent   = f.name;
      if (fileStatusEl) fileStatusEl.textContent  = formatBytes(f.size) + ' · Ready to go';
      if (filePreview)  filePreview.hidden = false;
    }

    if (dropzone) {
      dropzone.addEventListener('click', function () { if (fileInput) fileInput.click(); });
      dropzone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (fileInput) fileInput.click(); }
      });
      ['dragenter', 'dragover'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); dropzone.classList.add('is-dragover'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); dropzone.classList.remove('is-dragover'); });
      });
      dropzone.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files ? e.dataTransfer.files[0] : null;
        handleFile(f);
      });
    }
    if (fileInput) {
      fileInput.addEventListener('change', function () { handleFile(fileInput.files[0]); });
    }

    /* ---- Step 4: billing/shipping addresses ---- */
    var CARD_ANIM_MS = 200;

    function openCard(wrapEl) {
      if (!wrapEl) return;
      wrapEl.hidden = false;
      var card = wrapEl.querySelector('.po-address-card');
      if (!card) return;
      // next frame -> transition in
      requestAnimationFrame(function () { card.classList.add('is-open'); });
    }
    function closeCard(wrapEl) {
      if (!wrapEl) return;
      var card = wrapEl.querySelector('.po-address-card');
      if (card) card.classList.remove('is-open');
      setTimeout(function () { wrapEl.hidden = true; }, CARD_ANIM_MS);
    }

    function focusFirstInput(wrapEl) {
      if (!wrapEl) return;
      var first = wrapEl.querySelector('input, select, textarea, button');
      if (first) first.focus();
    }

    function toggleBillingNew(on) {
      state.billingAddressSource = on ? 'new' : 'existing';
      if (on) openCard(billingNewWrap); else closeCard(billingNewWrap);
      // Keep the existing billing select visible/usable (UX requirement)
      if (billingAddBtn) billingAddBtn.hidden = on;
    }
    function toggleShippingNew(on) {
      state.shippingAddressSource = on ? 'new' : 'existing';
      if (on) openCard(shippingNewWrap); else closeCard(shippingNewWrap);
      // Keep the existing shipping select visible/usable (UX requirement)
      if (shippingAddBtn) shippingAddBtn.hidden = on;
    }

    function setShippingSameAsBilling(on) {
      state.shippingSameAsBilling = !!on;
      if (shipSameCb) shipSameCb.checked = !!on;

      if (on) {
        state.shippingAddressSource = 'same_as_billing';
        if (shippingWrap) shippingWrap.hidden = true;
        if (shippingNewWrap) shippingNewWrap.hidden = true;
      } else {
        state.shippingAddressSource = (state.shippingAddressSource === 'same_as_billing') ? 'existing' : state.shippingAddressSource;
        if (shippingWrap) shippingWrap.hidden = false;
        if (state.shippingAddressSource === 'new') {
          if (shippingNewWrap) shippingNewWrap.hidden = false;
        }
      }
    }

    function syncShippingToBilling() {
      if (!state.shippingSameAsBilling) return;
      if (state.billingAddressSource === 'existing') {
        state.shippingAddrIdx = state.addrIdx;
        if (shippingSelect) shippingSelect.value = String(state.addrIdx);
      }
    }

    if (addrSelect) {
      addrSelect.addEventListener('change', function () {
        state.addrIdx = parseInt(addrSelect.value, 10) || 0;
        syncShippingToBilling();
      });
    }
    if (shippingSelect) {
      shippingSelect.addEventListener('change', function () {
        state.shippingAddrIdx = parseInt(shippingSelect.value, 10) || 0;
      });
    }
    if (shipSameCb) {
      shipSameCb.addEventListener('change', function () {
        setShippingSameAsBilling(shipSameCb.checked);
        syncShippingToBilling();
      });
    }
    if (billingAddBtn) billingAddBtn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleBillingNew(true);
      setTimeout(function () { focusFirstInput(billingNewWrap); }, 0);
    });
    function closeBillingCardAndFocusTrigger() {
      toggleBillingNew(false);
      if (billingAddBtn) billingAddBtn.focus();
      syncShippingToBilling();
    }
    if (billingCancel) billingCancel.addEventListener('click', function (e) { e.preventDefault(); closeBillingCardAndFocusTrigger(); });
    if (billingCloseBtn) billingCloseBtn.addEventListener('click', function (e) { e.preventDefault(); closeBillingCardAndFocusTrigger(); });
    if (billingSaveBtn) billingSaveBtn.addEventListener('click', function (e) {
      e.preventDefault();
      clearErrors();
      var billingAddr = readNewAddress('billing');
      var billErr = validateNewAddress(billingAddr, 'Billing address');
      if (billErr) { showError(4, billErr); focusFirstInput(billingNewWrap); return; }

      var newIdx = addNewAddressToDropdowns(billingAddr);
      state.addrIdx = newIdx;
      state.billingAddressSource = 'existing';
      if (addrSelect) addrSelect.value = String(newIdx);

      closeCard(billingNewWrap);
      if (billingAddBtn) {
        billingAddBtn.hidden = false;
        billingAddBtn.focus();
      }
      syncShippingToBilling();
    });

    if (shippingAddBtn) shippingAddBtn.addEventListener('click', function (e) {
      e.preventDefault();
      // If user wants a new shipping address, they must be in "separate shipping" mode.
      setShippingSameAsBilling(false);
      toggleShippingNew(true);
      setTimeout(function () { focusFirstInput(shippingNewWrap); }, 0);
    });
    function closeShippingCardAndFocusTrigger() {
      toggleShippingNew(false);
      if (shippingAddBtn) shippingAddBtn.focus();
    }
    if (shippingCancel) shippingCancel.addEventListener('click', function (e) { e.preventDefault(); closeShippingCardAndFocusTrigger(); });
    if (shippingCloseBtn) shippingCloseBtn.addEventListener('click', function (e) { e.preventDefault(); closeShippingCardAndFocusTrigger(); });
    if (shippingSaveBtn) shippingSaveBtn.addEventListener('click', function (e) {
      e.preventDefault();
      clearErrors();
      var shippingAddr = readNewAddress('shipping');
      var shipErr = validateNewAddress(shippingAddr, 'Shipping address');
      if (shipErr) { showError(4, shipErr); focusFirstInput(shippingNewWrap); return; }

      var newIdx = addNewAddressToDropdowns(shippingAddr);
      state.shippingAddrIdx = newIdx;
      state.shippingAddressSource = 'existing';
      if (shippingSelect) shippingSelect.value = String(newIdx);

      closeCard(shippingNewWrap);
      if (shippingAddBtn) {
        shippingAddBtn.hidden = false;
        shippingAddBtn.focus();
      }
    });

    // init: checkbox defaults to checked in markup; keep internal state consistent
    setShippingSameAsBilling(true);
    toggleBillingNew(false);
    toggleShippingNew(false);

    /* ---- navigation ---- */
    function validateStep(step) {
      clearErrors();
      if (step === 1) {
        if (state.brandIdx < 0 || !cfg.brands[state.brandIdx]) {
          showError(1, 'Please select a brand to continue.');
          return false;
        }
      }
      if (step === 3) {
        if (!state.file) {
          showError(3, 'Please upload your completed order file.');
          return false;
        }
      }
      return true;
    }

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var from = parseInt(btn.closest('[data-pof-panel]').getAttribute('data-pof-panel'), 10);
        if (!validateStep(from)) return;
        if (from === 1) updateDownloadStep();
        var to = from + 1;
        if (typeof state.maxStepReached === 'number') {
          state.maxStepReached = Math.max(state.maxStepReached, to);
        } else {
          state.maxStepReached = to;
        }
        goTo(to);
      });
    });

    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var from = parseInt(btn.closest('[data-pof-panel]').getAttribute('data-pof-panel'), 10);
        goTo(from - 1);
      });
    });

    /* ---- submit ---- */
    function getExistingAddress(idx) {
      var addresses = cfg.customer.addresses || [];
      return addresses[idx] || addresses[0] || {};
    }

    function readNewAddress(kind) {
      var src = kind === 'billing' ? billingNew : shippingNew;
      function v(el) { return (el && el.value ? el.value.trim() : ''); }
      return {
        id: '',
        company: v(src.company),
        firstName: v(src.first),
        lastName: v(src.last),
        address1: v(src.address1),
        address2: v(src.address2),
        city: v(src.city),
        province: '',
        zip: v(src.zip),
        country: v(src.country),
        phone: v(src.phone)
      };
    }

    function formatAddressLabel(addr) {
      var parts = [];
      if (addr.company) parts.push(addr.company);
      var line = addr.address1 || '';
      if (addr.address2) line += ', ' + addr.address2;
      if (line) parts.push(line);
      var cityLine = ((addr.zip || '') + ' ' + (addr.city || '')).trim();
      if (cityLine) parts.push(cityLine);
      if (addr.country) parts.push(addr.country);
      return parts.join(', ');
    }

    function appendAddressOption(selectEl, idx, label) {
      if (!selectEl) return;
      var opt = document.createElement('option');
      opt.value = String(idx);
      opt.textContent = label;
      selectEl.appendChild(opt);
    }

    function addNewAddressToDropdowns(addr) {
      cfg.customer.addresses = cfg.customer.addresses || [];
      var newIdx = cfg.customer.addresses.length;
      cfg.customer.addresses.push({
        id: '',
        firstName: addr.firstName || '',
        lastName: addr.lastName || '',
        company: addr.company || '',
        address1: addr.address1 || '',
        address2: addr.address2 || '',
        city: addr.city || '',
        province: '',
        zip: addr.zip || '',
        country: addr.country || '',
        phone: addr.phone || ''
      });
      var label = formatAddressLabel(addr);
      appendAddressOption(addrSelect, newIdx, label);
      appendAddressOption(shippingSelect, newIdx, label);
      return newIdx;
    }

    function validateNewAddress(addr, label) {
      // Keep existing behavior: stored addresses are treated as valid.
      // Only validate when the user is entering a new address in Step 4.
      if (!addr) return label + ' is missing.';
      if (!addr.firstName) return label + ': First name is required.';
      if (!addr.lastName) return label + ': Last name is required.';
      if (!addr.address1) return label + ': Address 1 is required.';
      if (!addr.city) return label + ': City is required.';
      if (!addr.country) return label + ': Country is required.';
      return null;
    }

    function getBillingAddress() {
      if (state.billingAddressSource === 'new') return readNewAddress('billing');
      return getExistingAddress(state.addrIdx);
    }

    function getShippingAddress(billingAddr) {
      if (state.shippingSameAsBilling) return billingAddr || getBillingAddress();
      if (state.shippingAddressSource === 'new') return readNewAddress('shipping');
      return getExistingAddress(state.shippingAddrIdx);
    }

    async function submitOrder() {
      clearErrors();
      if (state.submitting) return;
      if (!state.file) { showError(4, 'File is missing. Please go back and upload a file.'); return; }

      var brand = cfg.brands[state.brandIdx];
      if (!brand) { showError(4, 'No brand selected.'); return; }

      var billingAddr = getBillingAddress();
      var shippingAddr = getShippingAddress(billingAddr);

      if (state.billingAddressSource === 'new') {
        var billErr = validateNewAddress(billingAddr, 'Billing address');
        if (billErr) { showError(4, billErr); return; }
      }
      if (!state.shippingSameAsBilling && state.shippingAddressSource === 'new') {
        var shipErr = validateNewAddress(shippingAddr, 'Shipping address');
        if (shipErr) { showError(4, shipErr); return; }
      }

      state.submitting = true;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

      try {
        var fd = new FormData();
        fd.append('brand_name', brand.name || '');
        fd.append('variant_id', brand.variantId || '');
        fd.append('po_number', '');
        fd.append('customer_id', String(cfg.customer.id || ''));
        fd.append('customer_first_name', cfg.customer.firstName || '');
        fd.append('customer_last_name', cfg.customer.lastName || '');
        fd.append('customer_email', cfg.customer.email || '');
        // Keep existing (flat) address fields untouched: they map to billing address.
        fd.append('company', billingAddr.company || '');
        fd.append('address1', billingAddr.address1 || '');
        fd.append('address2', billingAddr.address2 || '');
        fd.append('city', billingAddr.city || '');
        fd.append('province', billingAddr.province || '');
        fd.append('zip', billingAddr.zip || '');
        fd.append('country', billingAddr.country || '');
        fd.append('phone', billingAddr.phone || cfg.customer.phone || '');
        fd.append('vat_number', vatInput ? vatInput.value : '');
        fd.append('sample_file_url', brand.templateUrl || '');
        fd.append('file_name', state.file.name || '');
        fd.append('file_size', String(state.file.size || ''));
        fd.append('file', state.file);

        // Additive fields (do not remove/rename existing ones)
        fd.append('billingAddress', JSON.stringify({
          id: billingAddr.id || '',
          company: billingAddr.company || '',
          firstName: billingAddr.firstName || '',
          lastName: billingAddr.lastName || '',
          address1: billingAddr.address1 || '',
          address2: billingAddr.address2 || '',
          zip: billingAddr.zip || '',
          city: billingAddr.city || '',
          country: billingAddr.country || '',
          phone: billingAddr.phone || ''
        }));
        fd.append('shippingAddress', JSON.stringify({
          id: shippingAddr.id || '',
          company: shippingAddr.company || '',
          firstName: shippingAddr.firstName || '',
          lastName: shippingAddr.lastName || '',
          address1: shippingAddr.address1 || '',
          address2: shippingAddr.address2 || '',
          zip: shippingAddr.zip || '',
          city: shippingAddr.city || '',
          country: shippingAddr.country || '',
          phone: shippingAddr.phone || ''
        }));
        fd.append('shippingAddressIsSameAsBilling', state.shippingSameAsBilling ? 'true' : 'false');
        fd.append('addressSource', JSON.stringify({
          billing: state.billingAddressSource,
          shipping: state.shippingSameAsBilling ? 'same_as_billing' : state.shippingAddressSource
        }));

        await fetch(cfg.webhookUrl, { method: 'POST', body: fd, mode: 'no-cors' });

        console.log('Pre-order submitted to Make.');
        goTo('success');
      } catch (err) {
        console.error('Submit failed:', err);
        showError(4, 'Submission failed. Please try again.');
      } finally {
        state.submitting = false;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = cfg.texts.submitBtn || 'Submit Pre-Order';
        }
      }
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) { e.preventDefault(); submitOrder(); });
    }

    /* ---- init ---- */
    goTo(1);
  }
})();
